import { useState } from "react";
import Box from "@mui/material/Box";
import { Tabs } from "@covertree/ui/table/Tabs";
import { TabPanel } from "@covertree/ui/table/TabPanel";

import { Resident } from "@graphql/api";
import ResidentDetailsTabContent from "./content/ResidentDetailsTabContent";
import CoveragesTabContent from "./content/CoveragesTabContent";
import { ResidentDetailsTabIndex } from "../enums";
import DocumentsTabContent from "./content/DocumentsTabContent";
import { PhysicalMailNotificationEventsTabContent } from "@routing/Residents/ResidentsContent/ResidentDetails/ResidentDetailsContent/ResidentDetailsTabs/content/PhysicalMailNotificationEventsTabContent";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

const detailsTabs = [
  { value: "details", label: "Resident Details" },
  { value: "coverages", label: "Coverages" },
  { value: "documents", label: "Documents" },
  {
    value: "physicalMailNotificationEvents",
    label: "Physical Mail History",
  },
];

export default function ResidentDetailsTabs({ isLoading, resident }: Props) {
  const [activeTabIndex, setActiveTabIndex] = useState(
    ResidentDetailsTabIndex.Details
  );

  return (
    <>
      <Tabs
        tabs={detailsTabs}
        value={activeTabIndex}
        onChange={(index) => setActiveTabIndex(index)}
      />
      <Box display="flex" flex={1} pt={3} width="100%" flexDirection="column">
        <TabPanel
          index={ResidentDetailsTabIndex.Details}
          value={activeTabIndex}>
          <ResidentDetailsTabContent
            isLoading={isLoading}
            resident={resident}
          />
        </TabPanel>
        <TabPanel
          index={ResidentDetailsTabIndex.Coverages}
          value={activeTabIndex}>
          <CoveragesTabContent
            isLoading={isLoading}
            resident={resident}
            switchToDocuments={() =>
              setActiveTabIndex(ResidentDetailsTabIndex.Documents)
            }
          />
        </TabPanel>
        <TabPanel
          index={ResidentDetailsTabIndex.Documents}
          value={activeTabIndex}>
          <DocumentsTabContent isLoading={isLoading} resident={resident} />
        </TabPanel>
        <TabPanel
          index={ResidentDetailsTabIndex.PhysicalMailNotificationEvents}
          value={activeTabIndex}>
          <PhysicalMailNotificationEventsTabContent
            isLoading={isLoading}
            resident={resident}
          />
        </TabPanel>
      </Box>
    </>
  );
}
